import { render, staticRenderFns } from "./TeamRoleEdit.vue?vue&type=template&id=36196726&"
import script from "./TeamRoleEdit.vue?vue&type=script&lang=js&"
export * from "./TeamRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports